// Device Controls Page Translations
// Supported languages: English (en), Danish (da)
const controlTranslations = {
  en: {
    title: "Device Controls",
    heading: "Cleaning zones",
    driveToDock: "DRIVE TO CHARGING STATION",
    cancelDocking: "CANCEL DOCKING",
    robotStatus: "Robot Status",
    cleaningIntensity: "Cleaning Intensity",
    operatingState: "State",
    battery: "Battery",
    support: "SUPPORT",
    currentzone: "Current zone",
    multiClean: "Multi Clean",

    // Device status translations
    status: {
      charging: "Charging",
      charged: "Charged",
      cleaning: "Cleaning",
      cleaningzone: "Cleaning",
      stopped: "Stopped",
      idle: "Idle",
      error: "Error",
      returning: "Returning",
      unavailable: "Unavailable",
      busy: "Station busy",
      drying: "On the station: drying mop",
    },

    // Robot activity (cleaning_step), e.g. Bosch/Home Connect process phases
    activity: {
      vacuumingandmopping: "Vacuuming and mopping",
      vacuuming: "Vacuuming",
      mopping: "Mopping",
      cleaning: "Cleaning",
      localizing: "Locating itself",
      returningtostation: "Returning to station",
      servicebreak: "Station break (mop service)",
      chargingbreak: "Charging break",
      washingmop: "Washing mop",
      dryingmop: "Drying mop",
      emptyingdustbox: "Emptying dust box",
      startingscheduledtask: "Starting scheduled task",
      mappingcomplete: "Mapping complete",
      docked: "On the station",
      stationprogram: "Mop drying program",
    },

    // Button action labels
    buttonStatus: {
      start: "Start",
      stop: "Stop",
      resume: "Resume",
      disabled: "Disabled",
      select: "Select",
      cancel: "Cancel",
      tapSelect: "Tap to select",
      starting: "Starting…",
      stopping: "Stopping…",
      selected: "Selected",
    },

    cleaningLevelSlider: {
      label: "Cleaning Intensity",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very High",
      fast: "Quick",
      normal: "Normal",
      intense: "Intense",
    },

    // Support modal translations
    supportModal: {
      title: "Contact Support",
      description: "Please provide a short message for our team:",
      supportMessageLabel: "Support Message",
      cancel: "Cancel",
      send: "Send Support Request",
      success: "Support request sent successfully!",
      close: "Close",
      sendingSupportRequest: "Sending support request...",
      success: "Support request sent successfully!",
      error: "Error sending support request. Please try again.",
    },

    // Loading modal translations
    loadingModal: {
      gettingReady: "Getting ready to clean...",
      returningToDock: "Returning to dock...",
      stopping: "Stopping in progress...",
      resuming: "Resuming cleaning...",
      pleaseWait: "Please wait...",
      actionNotPossible: "Action is not possible at this time",
      sendingSupportRequest: "Sending support request...",
    },

    // Feedback Modal translations
    feedbackModal: {
      title: "How clean is the floor this morning?",
      description: "",
      submitLabel: "Submit Feedback",
      closeLabel: "Later",
      savingLabel: "Saving...",
      experiencePrompt: "What best describes your experience?",
      experienceCommentLabel: "Additional comment (optional)",
      experienceOptions: {
        gumOnFloor: "Gum on floor",
        dockingIssue: "Docking issue",
        dirtyEdges: "Dirty edges",
        streaks: "Streaks",
        doorIssue: "Door issue",
        controlsIssue: "Controls issue",
      },
    },

    manualModeModal: {
      title: "Manual mode activated",
      description:
        "Device controls cannot be used while the robot is in manual mode. Please lower the handlebar on the robot to use these controls.",
    },

    modalStatus: {
      charging: "Charging...",
      charged: "Charged",
      docked: "Docked",
      undocking: "Undocking...",
      cleaning: "Cleaning...",
      resting: "Resting",
      idle: "Idle",
      stationary: "Stationary",
      error: "Error",
      fault: "Fault",
      returning: "Returning...",
      dockingInProgress: "Docking...",
      dockingMove: "Moving to dock...",
      stopped: "Stopped",
      paused: "Paused",
      dockingPaused: "Docking paused",
      cleaningPaused: "Cleaning paused",
      teleoping: "Remote control",
      teleopClean: "Remote cleaning",
    },

    // Shared cleaning session (same on every controls page)
    session: {
      zoneProgress: "Zone {current} of {total}",
      zonesProgress: "Zones {first}–{last} of {total}",
      startedBy: "Started by {name}",
      preset: "Program: {name}",
      automation: "automation",
      aUser: "a user",
      remaining: "~{minutes} min left",
      coverage: "{extent}% covered",
      waitingNextZone: "Zone finished, starting next zone...",
      undocking: "Leaving the charging station...",
      held: "Cleaning is on hold",
      stoppingRobot: "Stopping the robot… (tap Stop again if it keeps cleaning)",
      stopNotConfirmed:
        "The robot did not stop. Press Stop again, or end the cleaning.",
      heldHint:
        "The robot was stopped or is busy. Continue when it is ready, or end the cleaning.",
      interrupted: "Cleaning was interrupted",
      continue: "CONTINUE",
      end: "END CLEANING",
      continued: "Cleaning continued",
      ended: "Cleaning ended",
      alreadyRunning: "Robot is already cleaning (started by {name})",
      completed: "All zones cleaned",
      failed: "Cleaning could not be started",
    },

    // Pop-up messages (snackbars) on the controls page
    notify: {
      returnedCharging: "Robot has returned to the charging station and is charging",
      robotError: "Robot has encountered an error",
      startedCleaning: "Robot started cleaning",
      stoppedCleaning: "Robot has stopped cleaning",
      returning: "Robot is returning to the charging station",
      started: "Started cleaning {zone}",
      multiStarted: "Started multi clean of {count} zones",
      startFailed: "Could not start cleaning {zone}. Please try again.",
      actionFailed: "The command did not reach the robot. Please try again.",
      paused: "Robot paused",
      stopSent: "Stop sent to the robot",
      resumed: "Robot resumed cleaning",
      docking: "Robot is driving to the charging station",
      multiCleanMinZones: "Select at least 2 zones to start multi clean",
      ratingRequired: "Please choose a rating between 1 and 5",
      experienceRequired: "Please select at least one floor experience before submitting",
      feedbackThanks: "Thank you for your feedback",
      feedbackFailed: "Could not send feedback: {error}",
      refreshDeviceData: "Refresh device data",
    },

    // Device list (/device-controls) and robot cards
    deviceList: {
      heading: "Available robots",
      subtitle: "Select a robot to see its controls and status",
      loadFailed: "Could not load robots",
      none: "No robots found",
      controls: "Controls",
      unnamed: "Unnamed robot",
      uuid: "UUID",
      serial: "S/N",
      previous: "Previous robots",
      next: "Next robots",
    },

    // Top bar for control users
    nav: {
      back: "Back to robots",
      refresh: "Refresh",
      language: "Language",
      english: "English",
      danish: "Dansk",
    },

    // General translations
    loading: "Loading...",
    error: "Error occurred",
    noZones: "Robot not currently configured with cleaning zones",
    cancel: "Cancel",
    send: "Send",
  },

  da: {
    title: "Fjernstyring",
    heading: "Områder",
    driveToDock: "KØR TIL LADESTATION",
    cancelDocking: "AFBRYD DOCKNING",
    support: "TILKALD FJERNSUPPORT",
    robotStatus: "Robotstatus",
    operatingState: "Status",
    battery: "Batteri",
    cleaningIntensity: "Rengøringsintensitet",
    currentzone: "Nuværende område",
    multiClean: "Multi-Rengøring",

    // Device status translations
    status: {
      charging: "Oplader",
      charged: "Opladet",
      cleaning: "Rengører",
      cleaningzone: "Rengører",
      stopped: "Stoppet",
      idle: "Inaktiv",
      error: "Fejl",
      returning: "Kører tilbage",
      unavailable: "Utilgængelig",
      busy: "Station optaget",
      drying: "På stationen: tørrer moppen",
    },

    // Robottens aktivitet (cleaning_step), f.eks. Bosch/Home Connect faser
    activity: {
      vacuumingandmopping: "Støvsuger og mopper",
      vacuuming: "Støvsuger",
      mopping: "Mopper",
      cleaning: "Rengører",
      localizing: "Finder sin position",
      returningtostation: "Kører til stationen",
      servicebreak: "Stationspause (mopservice)",
      chargingbreak: "Opladningspause",
      washingmop: "Vasker moppen",
      dryingmop: "Tørrer moppen",
      emptyingdustbox: "Tømmer støvbeholderen",
      startingscheduledtask: "Starter planlagt opgave",
      mappingcomplete: "Kortlægning færdig",
      docked: "På stationen",
      stationprogram: "Moptørringsprogram",
    },

    // Button action labels
    buttonStatus: {
      start: "Start",
      stop: "Stop",
      resume: "Genoptag",
      disabled: "Deaktiveret",
      select: "Vælg",
      cancel: "Annuller",
      tapSelect: "Tryk for at vælge",
      starting: "Starter…",
      stopping: "Stopper…",
      selected: "Valgt",
    },

    cleaningLevelSlider: {
      label: "Rengøringsintensitet",
      low: "Lav",
      medium: "Mellem",
      high: "Høj",
      veryHigh: "Meget høj",
      fast: "Hurtig",
      normal: "Normal",
      intense: "Intens",
    },
    // Support modal translations
    supportModal: {
      title: "Kontakt support",
      description: "Angiv venligst en kort besked til vores team:",
      supportMessageLabel: "Supportbesked",
      cancel: "Annuller",
      send: "Send anmodning om support",
      success: "Supportanmodning sendt med succes!",
      close: "Luk",
      sendingSupportRequest: "Sender supportanmodning...",
      success: "Supportanmodning sendt med succes!",
      error: "Fejl ved afsendelse af supportanmodning. Prøv igen.",
    },

    // Loading modal translations
    loadingModal: {
      gettingReady: "Klargører rengøring...",
      returningToDock: "Kører tilbage til ladestationen...",
      stopping: "Annullerer...",
      resuming: "Genoptager rengøring...",
      pleaseWait: "Vent venligst...",
      actionNotPossible: "Ikke muligt på nuværende tidspunkt",
      sendingSupportRequest: "Sender supportanmodning...",
    },

    // Feedback Modal translations
    feedbackModal: {
      title: "Hvor rent er gulvet i butikken her til morgen?",
      description: "",
      submitLabel: "Indsend feedback",
      closeLabel: "Senere",
      savingLabel: "Gemmer...",
      experiencePrompt: "Hvad beskriver bedst din oplevelse?",
      experienceCommentLabel: "Ekstra kommentar (valgfri)",
      experienceOptions: {
        gumOnFloor: "Tyggegummi på gulvet",
        dockingIssue: "Dokningsproblem",
        dirtyEdges: "Snavs ved kanter",
        streaks: "Striber på gulvet",
        doorIssue: "Dørproblem",
        controlsIssue: "Problem med tablet eller app",
      },
    },

    manualModeModal: {
      title: "Manuel tilstand aktiveret",
      description:
        "Fjernstyring kan ikke bruges, mens robotten er i manuel tilstand. Sænk håndtaget på robotten for at bruge disse kontroller.",
    },

    modalStatus: {
      charging: "Oplader...",
      charged: "Opladet",
      docked: "Docket",
      undocking: "Forlader ladestation...",
      cleaning: "Rengører...",
      resting: "Standby",
      idle: "Inaktiv",
      stationary: "Stationær",
      error: "Fejl",
      fault: "Defekt",
      returning: "Returnerer...",
      dockingInProgress: "Kører i ladestation...",
      dockingMove: "Kører til ladestation...",
      stopped: "Stoppet",
      paused: "Pauset",
      dockingPaused: "Dockning pauset",
      cleaningPaused: "Rengøring pauset",
      teleoping: "Fjernstyring",
      teleopClean: "Fjernrengøring",
    },

    // Fælles rengøringssession (samme på alle fjernstyringssider)
    session: {
      zoneProgress: "Område {current} af {total}",
      zonesProgress: "Områder {first}–{last} af {total}",
      startedBy: "Startet af {name}",
      preset: "Program: {name}",
      automation: "automatik",
      aUser: "en bruger",
      remaining: "ca. {minutes} min tilbage",
      coverage: "{extent}% dækket",
      waitingNextZone: "Område færdigt, starter næste område...",
      undocking: "Forlader ladestationen...",
      held: "Rengøringen er sat på hold",
      stoppingRobot: "Stopper robotten… (tryk Stop igen hvis den fortsætter)",
      stopNotConfirmed:
        "Robotten stoppede ikke. Tryk Stop igen, eller afslut rengøringen.",
      heldHint:
        "Robotten blev stoppet eller er optaget. Fortsæt når den er klar, eller afslut rengøringen.",
      interrupted: "Rengøringen blev afbrudt",
      continue: "FORTSÆT",
      end: "AFSLUT RENGØRING",
      continued: "Rengøringen fortsætter",
      ended: "Rengøringen er afsluttet",
      alreadyRunning: "Robotten rengør allerede (startet af {name})",
      completed: "Alle områder er rengjort",
      failed: "Rengøringen kunne ikke startes",
    },

    // Pop op-beskeder på fjernstyringssiden
    notify: {
      returnedCharging: "Robotten er kørt tilbage til ladestationen og oplader",
      robotError: "Robotten er stødt på en fejl",
      startedCleaning: "Robotten er begyndt at gøre rent",
      stoppedCleaning: "Robotten er stoppet med at gøre rent",
      returning: "Robotten kører tilbage til ladestationen",
      started: "Rengøring af {zone} er startet",
      multiStarted: "Multi-Rengøring af {count} områder er startet",
      startFailed: "Rengøring af {zone} kunne ikke startes. Prøv igen.",
      actionFailed: "Kommandoen nåede ikke frem til robotten. Prøv igen.",
      paused: "Robotten er pauset",
      stopSent: "Stop er sendt til robotten",
      resumed: "Robotten fortsætter rengøringen",
      docking: "Robotten kører til ladestationen",
      multiCleanMinZones: "Vælg mindst 2 områder for at starte Multi-Rengøring",
      ratingRequired: "Vælg en vurdering mellem 1 og 5",
      experienceRequired: "Vælg mindst én oplevelse af gulvet, før du sender",
      feedbackThanks: "Tak for din feedback",
      feedbackFailed: "Feedback kunne ikke sendes: {error}",
      refreshDeviceData: "Opdater robotdata",
    },

    // Robotliste (/device-controls) og robotkort
    deviceList: {
      heading: "Tilgængelige robotter",
      subtitle: "Vælg en robot for at se betjening og status",
      loadFailed: "Robotterne kunne ikke hentes",
      none: "Ingen robotter fundet",
      controls: "Betjening",
      unnamed: "Robot uden navn",
      uuid: "UUID",
      serial: "S/N",
      previous: "Forrige robotter",
      next: "Næste robotter",
    },

    // Topbjælke for fjernstyringsbrugere
    nav: {
      back: "Tilbage til robotter",
      refresh: "Opdater",
      language: "Sprog",
      english: "English",
      danish: "Dansk",
    },

    // General translations
    loading: "Indlæser...",
    error: "Fejl opstået",
    noZones: "Robot ikke konfigureret med rengøringsområder",
    cancel: "Annuller",
    send: "Send",
  },
};

// Look up "section.key" for a language, with {placeholder} values; falls back to English, then the key
export function translateControl(language, key, values = {}) {
  const find = (lang) =>
    key.split(".").reduce((node, part) => node?.[part], controlTranslations[lang]);
  const text = find(language) ?? find("en") ?? key;
  return Object.entries(values).reduce(
    (result, [name, value]) => result.replace(`{${name}}`, value ?? ""),
    String(text),
  );
}

export default controlTranslations;
